// extracted by mini-css-extract-plugin
export var resizer = "_gg-0";